export const documentation = {
  junior: [
    { name: 'Mobile Development Standards', url: '/docs/mobile-standards', type: 'standards' },
    { name: 'Code Review Guidelines for Mobile', url: '/docs/mobile-code-review', type: 'process' },
    { name: 'Mobile UI/UX Guidelines', url: '/docs/mobile-ui-guidelines', type: 'design' },
    { name: 'Mobile Testing Best Practices', url: '/docs/mobile-testing', type: 'testing' },
    { name: 'App Store Submission Process', url: '/docs/app-store-submission', type: 'deployment' }
  ],
  mid: [
    { name: 'Mobile Architecture Patterns', url: '/docs/mobile-architecture', type: 'architecture' },
    { name: 'Performance Optimization Guide', url: '/docs/mobile-performance', type: 'performance' },
    { name: 'Mobile Security Implementation', url: '/docs/mobile-security', type: 'security' },
    { name: 'Cross-platform Development Guide', url: '/docs/cross-platform', type: 'framework' },
    { name: 'Mobile CI/CD Pipeline Setup', url: '/docs/mobile-cicd', type: 'deployment' }
  ],
  senior: [
    { name: 'Mobile Technical Leadership Guide', url: '/docs/mobile-tech-leadership', type: 'leadership' },
    { name: 'Mobile Platform Strategy', url: '/docs/mobile-platform-strategy', type: 'strategy' },
    { name: 'Enterprise Mobile Architecture', url: '/docs/enterprise-mobile', type: 'architecture' },
    { name: 'Mobile Team Scaling Guide', url: '/docs/mobile-team-scaling', type: 'management' },
    { name: 'Mobile Innovation Framework', url: '/docs/mobile-innovation', type: 'innovation' }
  ]
};
